export default __webpack_public_path__ + "static/media/Group 8253.abc6709d.svg";